import { Component, ChangeDetectionStrategy } from '@angular/core';

import { Subject } from 'rxjs';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  IconButtonComponent,
  ButtonComponent,
  DropdownComponent,
  DropdownWidth,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-link-tooltip',
  templateUrl: './link-tooltip.component.html',
  styleUrls: ['./link-tooltip.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonComponent, IconButtonComponent, TranslatePipe, DropdownComponent],
})
export class LinkTooltipComponent {
  protected readonly DropdownWidth = DropdownWidth;

  public open = new Subject<void>();
  public edit = new Subject<void>();
  public remove = new Subject<void>();
}
